import React from 'react';
import Grid from '../../common/Grid/Grid';
import CVCardItem from './CVCardItem';

const CVGrid = ({
  cvs,
  isLoading,
  isLoadingMore,
  pageInfo,
  handleItemClick,
  handleGridScroll,
  showLoadingSpinner,
  shouldHideContent,
  loadMoreData,
  gridRef,
  onView,
}) => {
  // Custom renderer for CV items
  const renderCVItem = ({ item, onClick }) => {
    return <CVCardItem cv={item} onClick={onClick} onView={onView} />;
  };

  return (
    <Grid
      items={cvs}
      isLoading={isLoading}
      isLoadingMore={isLoadingMore}
      pageInfo={pageInfo}
      renderItem={renderCVItem}
      handleItemClick={handleItemClick}
      handleGridScroll={handleGridScroll}
      showLoadingSpinner={showLoadingSpinner}
      shouldHideContent={shouldHideContent}
      loadMoreData={loadMoreData}
      gridRef={gridRef}
      emptyStateTitle="No CVs Found"
      emptyStateDescription="No CVs found matching the current search criteria. Try adjusting your search or check back later."
      endOfListMessage="You've reached the end of the list"
    />
  );
};

export default CVGrid; 